module.exports = __webpack_public_path__ + "static/media/lefthn.15becf56.png";